import { Truck, RotateCcw, Shield, HeadphonesIcon } from "lucide-react";

const badges = [
  {
    icon: Truck,
    title: "Gratis Verzending",
    description: "Vanaf €50",
  },
  {
    icon: RotateCcw,
    title: "30 Dagen Retour",
    description: "Niet tevreden? Geld terug",
  },
  {
    icon: Shield,
    title: "Veilig Betalen",
    description: "iDEAL, PayPal, Creditcard",
  },
  {
    icon: HeadphonesIcon,
    title: "Klantenservice",
    description: "Altijd bereikbaar",
  },
];

const TrustBadges = () => {
  return (
    <section className="py-12 bg-secondary/30 border-y border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
          {badges.map((badge) => (
            <div key={badge.title} className="flex items-center gap-3 sm:gap-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
                <badge.icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-foreground text-sm">{badge.title}</p>
                <p className="text-xs text-muted-foreground">{badge.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
